import { ActionTree } from 'vuex';
import { normalize } from 'normalizr';
import { enrollment } from '@descomplica/dex-store/lib/normalizr_schema';
import RootState from '@/store/root_state';
import { EnrollmentState } from './state';
import enrollmentFixture from '../../../../tests/unit/fixtures/enrollmentFixture';

const actions: ActionTree<EnrollmentState, RootState> = {
  async PULL_ENROLLMENTS({ commit }) {
    const response = enrollmentFixture;

    const normalizedResponse = normalize(response.data.allEnrollments, {
      nodes: [enrollment],
    });

    commit('SET_ENROLLMENTS', normalizedResponse.entities);
    commit('SET_CLASSROOMS', normalizedResponse.entities);
  },
};

export default actions;
